import { useEffect, FunctionComponent, ChangeEvent, JSXElementConstructor } from 'react'

import { RESPONSE_PENDING } from 'front-end-core/constants/responses'
import { noop, isEmpty } from 'libraries/lodash'
import cx from 'classnames'

import ResponseConsumer from 'components/shared/ResponseConsumer'

import QaAccordionNotFoundContainer from 'redux/containers/components/accordion/QaAccordionNotFoundContainer'
import AccordionFoundContainer from 'redux/containers/components/accordion/AccordionFoundContainer'
import useClickEvents from 'hooks/useClickEvents'
import { AccordionWrapperContainerProps } from 'redux/containers/components/accordion/AccordionWrapperContainer'
import { AccordionState } from '../../redux/reducers/accordion';
import { ExpandCallback, SelectCallback } from 'interfaces/accordion'

const offsetParent = (nodeName:string, element: HTMLElement|null):HTMLElement|null =>
  !element || element.nodeName.toLowerCase() === nodeName
    ? element
    : offsetParent(nodeName, element.parentElement)

const AccordionWrapper:FunctionComponent<AccordionWrapperProps> = (props:AccordionWrapperProps) => {
  const {
    setAccordionExpandedNodeId,
    setAccordionExpandedNodeTitle,
    setAccordionGroup,
    setAccordionUrlNode,
    group = RESPONSE_PENDING,
    expandCallback = noop,
    selectCallback = noop,
    eventCategory = 'Accordion',
    setAccordionState,
    highlight,
    sectionId,
    flavour,
    flavoured = false,
    updateExpandedNodeIdState,
    pageToggleRight,
    aol
  } = props

  useEffect(() => {
    const resetAccordion = () => {
      setAccordionExpandedNodeId(null)
      setAccordionExpandedNodeTitle(null)
      setAccordionGroup(RESPONSE_PENDING)
      setAccordionUrlNode(null)
    }
    resetAccordion()

    return resetAccordion
  }, [])

  useEffect(() => {
    setAccordionState({ highlight, eventCategory, expandCallback, group, sectionId })
  }, [highlight, eventCategory, expandCallback, group, sectionId])

  const { handleClick } = useClickEvents({ pageToggleRight })

  const handleChange = (evt: ChangeEvent<HTMLDivElement>) => {
    const { action, type, path, value } = evt.target.dataset || {}
    const callback: (...args: any[]) => any = (action === 'expand') ? expandCallback : selectCallback

    if (callback(path, type, flavour, +value!, aol) && action === 'expand') {
      const { target } = evt
      const { id } = offsetParent('li', target)!
      updateExpandedNodeIdState(id, value)
    }
  }

  const className = cx({ flavoured: !!flavoured })

  return (
    <div
      className={className}
      onClick={handleClick}
      onChange={handleChange}
    >
      <ResponseConsumer
        response={group}
        skeleton='qa-accordion'
        notfoundComponent={() => <QaAccordionNotFoundContainer {...props} />}
        content={() => !isEmpty(group)
          ? <AccordionFoundContainer {...props} />
          : <QaAccordionNotFoundContainer {...props} />}
      />
    </div>
  )
}

interface AccordionWrapper extends ExpandCallback, SelectCallback{
  flavoured: boolean;
  adminBar: unknown; // FIX ME
  contained: boolean;
  SectionHeaderOverride: JSXElementConstructor<unknown>;
  section: string;
  cxNames: any; // FIX ME
  showAllS1: boolean;
  copyright: string;
  expandCallback: (...args:any) => any;
  selectCallback: (...args:any) => any;
}

export type AccordionWrapperProps =  AccordionWrapperContainerProps & AccordionState & AccordionWrapper;

export default AccordionWrapper
